

function ProjectItem(props) {
    const info = props.info

    return (
        <div className="projects-pane">
            <div className="project-item">
                <h3 className="project-item__project-title">{info.title}</h3>
                {info.screenshot ?
                    <img alt="screenshot of project" className="screenshot-container" src={info.screenshot}></img> :
                    <div>
                        {
                            info.displayiframe ?
                                <iframe className="iframe-container" title={`project`} src={info.projectLink}></iframe> :
                                <div className="iframe-container">No Sample</div>
                        }
                    </div>
                }
                <div className="relevant-skills-list">
                    {info.languagesList.map((skill, i) => <div className="applied-skill-item" key={i}> {skill} </div>)}
                </div>
                <p className="project-item__description">{info.description}</p>
                <div className="button-link-container">
                    {info.projectLink && <a href={info.projectLink} target="_blank" rel="noreferrer" className="link-button">View Project</a>}
                    {info.codeLink ?
                        <a href={info.codeLink} target="_blank" rel="noreferrer" className="link-button">View Source Code</a> :
                        <div className="link-button button-disabled"><i className="fa fa-eye-slash"></i></div>
                    }
                </div>
            </div>
        </div>
    )
}



export { ProjectItem }